import nativeToJsPlugin from './nativeToJsPlugin';
import { mutationTypes, actionTypes } from '../../../types';
import { logger } from '../../../tools/logger';

export default {
	state: {
		config: {
			blockerBonus: 0,
			blockerThreshold: -120,
			extenderThreshold: -120,
			hystereseWidth: 8,
			rssiThreshold: -120,
			ticsToWin: 1,
			triggerThreshold: -120,
			isActive: false,
		},
		winnerList: [],
		winner: null,
		winnerOfTypeTrigger: null,
	},
	getters: {
		nearestBeacon(state) {
			return state.winner;
		},
		nearestBeaconTrigger(state) {
			return state.winnerOfTypeTrigger;
		},
	},
	mutations: {
		[mutationTypes.nearestBeaconSetConfig](state, config) {
			state.config = Object.assign(state.config, config);
			logger.log('Nearest Beacon nearestBeaconSetConfig');
		},
		[mutationTypes.nearestBeaconSetWinner](state, { beacon }) {
			state.winner = JSON.parse(JSON.stringify(beacon));
			logger.log('Nearest Beacon set winner', state.winner);
		},
		[mutationTypes.nearestBeaconSetWinnerTypeTrigger](state, { beacon }) {
			logger.log('Nearest Beacon set nearestBeaconSetWinnerTypeTrigger', beacon);
			state.winnerOfTypeTrigger = JSON.parse(JSON.stringify(beacon));
		},

		[mutationTypes.nearestBeaconSetWinnerRssi](state, { rssi }) {
			state.winner.rssi = rssi;
		},
		[mutationTypes.nearestBeaconPushToWinnerList](state, { beacon }) {
			state.winnerList.push(beacon);
		},
		[mutationTypes.nearestBeaconShiftWinnerList](state) {
			state.winnerList.shift();
		},
		[mutationTypes.nearestBeaconWinnerOfTypeTrigger](state, { beacon }) {
			state.winnerOfTypeTrigger = beacon;
		},
	},
	actions: {
		[actionTypes.nearestBeaconStep]({ commit, state }, { detectedBeacons }) {
			const lastNearestBeacon = state.winner;
			const sortedBeaconList = Object.values(detectedBeacons).reduce((acc, beacon) => {
				let rssiThreshold;
				switch (beacon.type) {
					case 'blocker':
						rssiThreshold = state.config.blockerThreshold;
						beacon.rssi += state.config.blockerBonus || 0;
						if (lastNearestBeacon && beacon.url === lastNearestBeacon.url) {
							beacon.rssi += parseInt(state.config.hystereseWidth, 10);
						}
						break;
					case 'trigger':
						rssiThreshold = state.config.triggerThreshold;
						beacon.rssi += state.config.triggerBonus || 0;
						if (
							(state.winnerOfTypeTrigger && beacon.url === state.winnerOfTypeTrigger.url) ||
							(lastNearestBeacon && beacon.url === lastNearestBeacon.url)
						) {
							beacon.rssi += parseInt(state.config.hystereseWidth, 10);
						}
						break;
					case 'extender':
						rssiThreshold = state.config.extenderThreshold;
						beacon.rssi += state.config.extenderBonus || 0;
						if (
							(state.winnerOfTypeTrigger && beacon.url === state.winnerOfTypeTrigger.url) ||
							(lastNearestBeacon && beacon.url === lastNearestBeacon.url)
						) {
							beacon.rssi += parseInt(state.config.hystereseWidth, 10);
						}
						break;
					default:
						break;
				}
				if (beacon.rssi > rssiThreshold) {
					acc.push(beacon);
				}
				return acc;
			}, []);

			sortedBeaconList.sort((a, b) => b.rssi - a.rssi);
			// logger.log('nearestBeacon: calcNearestBeacon: sortedList ', sortedBeaconList.map(b => `${b.minor}#${b.rssi}`));
			// logger.log('nearestBeacon: calcNearestBeacon: state.winnerOfTypeTrigger ',JSON.stringify(state.winnerOfTypeTrigger, null, 3));
			// logger.log('nearestBeacon: calcNearestBeacon: lastNearestBeacon ', JSON.stringify(lastNearestBeacon, null, 3));

			let tempWinner = state.winner;
			if (sortedBeaconList.length > 0) {
				if (lastNearestBeacon == null || lastNearestBeacon.url === sortedBeaconList[0].url) {
					[tempWinner] = sortedBeaconList; // Nearest Beacon changed du first beacon was found
				} else {
					commit(mutationTypes.nearestBeaconSetWinner, {
						beacon: sortedBeaconList.find(beacon => beacon.url === lastNearestBeacon.url) || null,
					});
					if (state.winner == null || state.winner.rssi < sortedBeaconList[0].rssi) {
						[tempWinner] = sortedBeaconList; // Nearest beacon changed new Stronges Beacon
					}
				}
			}

			// Last Rounds Winner checking
			if (tempWinner) {
				commit(mutationTypes.nearestBeaconPushToWinnerList, {
					beacon: JSON.parse(JSON.stringify(tempWinner)),
				});
			}

			while (state.winnerList.length > state.config.ticsToWin * 2 - 1) {
				commit(mutationTypes.nearestBeaconShiftWinnerList); // pull last element to contain window.length
			}

			const resultMap = state.winnerList.reduce((acc, beacon) => {
				if (beacon) {
					acc[beacon.url] = beacon && acc[beacon.url] ? acc[beacon.url] + 1 : 1;
					if (acc[beacon.url] >= state.config.ticsToWin) {
						// logger.log('found Winner ' + beacon.url);
						acc.winner = beacon;
					}
				}
				return acc;
			}, {});
			if (resultMap.winner) {
				tempWinner = resultMap.winner;
			} else {
				// If there is no winner stick to the last Winner
				// state.winner = lastNearestBeacon;
				if (state.winner) commit(mutationTypes.nearestBeaconSetWinnerRssi, { rssi: tempWinner.rssi });
			}

			// only update winner if it has really changed so watching components only get updated beacon url change
			if (
				(lastNearestBeacon !== null && tempWinner === null) ||
				(lastNearestBeacon === null && tempWinner !== null) ||
				(lastNearestBeacon !== null && tempWinner !== null && lastNearestBeacon.url !== tempWinner.url)
			) {
				commit(mutationTypes.nearestBeaconSetWinner, { beacon: tempWinner });
				if (tempWinner !== null && (tempWinner.type === 'trigger' || tempWinner.type === 'extender')) {
					commit(mutationTypes.nearestBeaconWinnerOfTypeTrigger, { beacon: state.winner }); // update last Trigger beacon if it is no an blocker
				}
			}
		},
	},
	plugins: [nativeToJsPlugin],
};
